<div class="row" *ngIf="!isLoading">
  <div class="col-sm-6 filter-box">
    <ngx-treeview
      [config]="config"
      [items]="items"
      [itemTemplate]="itemTemplate"
      (selectedChange)="onSelectedChange($event)">
    </ngx-treeview>
  </div>
</div>
<div class="row">
  <!-- Loading Style -->
  <div class="preloader3 loader-block mx-auto" *ngIf="isLoading">
    <div class="circ1 loader-success"></div>
    <div class="circ2 loader-success"></div>
    <div class="circ3 loader-success"></div>
  </div>
</div>
<div class="card-block-hid ng-trigger ng-trigger-cardToggle" style="overflow: hidden;">
  <div class="card-block pull-right">
    <button (click)="navigatedToOverview()" class="btn btn-link me-4"
            type="button">{{'global.cancel'|translate}}</button>
    <button (click)="saveProducts()" class="btn btn-primary ripple light"
            type="button">{{'global.save_changes'|translate}}</button>
  </div>
</div>

<ng-template #itemTemplate let-item="item" let-onCollapseExpand="onCollapseExpand"
             let-onCheckedChange="onCheckedChange">
  <div class="form-inline row-item">
    <i *ngIf="item.children" (click)="onCollapseExpand()" aria-hidden="true" class="fa"
       [class.fa-caret-right]="item.collapsed"
       [class.fa-caret-down]="!item.collapsed"></i>
    <div class="form-check">
      <input type="checkbox" class="form-check-input" [(ngModel)]="item.checked" (ngModelChange)="onCheckedChange()"
             [disabled]="item.disabled"
             [indeterminate]="item.indeterminate"/>
      <label class="form-check-label" (click)="item.checked = !item.checked; onCheckedChange()">
        {{item.text}}
      </label>
    </div>
  </div>
</ng-template>
